/*
 * Action Types
 */
export enum ElementRefTypes {
  SET_CURRENT_REF = '@ref/SET_CURRENT_REF',
}

/*
 * State type
 */
export interface ElementRefState {
  readonly currentRef: string;
}
